export const DataLogicType = {
    Association: "Association",
    Attachment: "Attachment",
    BizObject: "BizObject",
    BizObjectArray: "BizObjectArray",
    BizStructure: "BizStructure",
    BizStructureArray: "BizStructureArray",
    Bool: "Bool",
    BoolArray: "BoolArray",
    ByteArray: "ByteArray",
    Comment: "Comment",
    DateTime: "DateTime",
    DateTimeArray: "DateTimeArray",
    Decimal: "Decimal",
    DecimalArray: "DecimalArray",
    Double: "Double",
    DoubleArray: "DoubleArray",
    GlobalData: "GlobalData",
    Guid: "Guid",
    GuidArray: "GuidArray",
    Html: "Html",
    HyperLink: "HyperLink",
    Int: "Int",
    IntArray: "IntArray",
    Long: "Long",
    LongArray: "LongArray",
    MultiParticipant: "MultiParticipant",
    Object: "Object",
    ShortString: "ShortString",
    SingleParticipant: "SingleParticipant",
    String: "String",
    StringArray: "StringArray",
    TimeSpan: "TimeSpan",
    Unspecified: "Unspecified",
    Xml: "Xml",
    Json: "Json",
    FormArea: "FormArea"
}